import React from 'react'

import { useTranslation } from 'react-i18next'

import { Button, spacing, Stack, Text } from '@cash-design-system/react'

export function BlockerSupportRequired(): React.ReactElement {
  const { t } = useTranslation()

  const goToSupport = () => {
    window.open('/support', '_blank')
  }
  return (
    <Stack space={spacing.xxl}>
      <Text typography="numeralSmall" as="h2" color="textStandard">
        {t('For your security, please contact support to reset your Cash PIN.', { context: 'modal title' })}
      </Text>

      <Button size="large" variant="secondary" onClick={goToSupport}>
        {t('Contact Support', { context: 'modal button that navigates to the Support website' })}
      </Button>
    </Stack>
  )
}
